/* eslint-disable no-nested-ternary */
export const getDocumentWizardConfig = (
  verificationType,
  docId
) => {
  switch(verificationType) {
    case 'awardLetter':
      return {
        verificationType: 'awardLetter',
        displayName: 'Award Letter',
        heading: [
          'Upload your most recent award letter'
        ],
        verifyHeading: [
          'For us to verify your documents and protect your delivery slot, please ensure:'
        ]
      };

    case 'bankStatement':
      return {
        verificationType: 'bankStatement',
        displayName: 'Bank Statement',
        heading: [
          'Upload your most recent bank statement'
        ],
        verifyHeading: [
          'For us to verify your documents and protect your delivery slot, please ensure:'
        ]
      };

    case 'bankStatements':
      return {
        verificationType: 'bankStatements',
        displayName: 'Bank Statement',
        heading: [
          `Upload your ${docId === 2 ? '2nd' : docId === 3 ? '3rd' : ''} most recent bank statement`
        ],
        verifyHeading: [
          'For us to verify your documents and protect your delivery slot, please ensure:'
        ]
      };

    case 'unknownProofOfResidency':
      return {
        verificationType: 'unknownProofOfResidency',
        displayName: 'Proof of Residency',
        heading: [
          `Upload a Proof of Residency Document`
        ],
        verifyHeading: [
          'For us to verify your documents and protect your delivery slot, please ensure:'
        ]
      };

    case 'payStubs':
      return {
        verificationType: 'payStub',
        displayName: 'Pay Stub',
        heading: [
          `Upload your ${docId === 2 ? '2nd' : ''} most recent pay stub`
        ],
        verifyHeading: [
          `Upload your ${docId === 2 ? '2nd' : ''} most recent pay stub`
        ]
      };

    default:
      return {
        verificationType: 'document',
        displayName: 'Upload Document',
        heading: [
          `Upload your document`
        ],
        verifyHeading: [
          'For us to verify your documents and protect your delivery slot, please ensure:'
        ]
      }
  };
};
